import AccountClient from './accountClient';

export class AccountService {
  registerUser(userData) {
    return AccountClient.registerUser({ locale: 'fi', ...userData }).then(
      (response) => response.result,
    );
  }

  getEmailAvailability(email) {
    return AccountClient.getEmailAvailability(email);
  }

  sendResetPasswordEmail(email) {
    return AccountClient.sendResetPasswordEmail(email);
  }

  resetUserPassword(userData) {
    return AccountClient.resetUserPassword(userData);
  }

  requestEmailVerification(userId) {
    return AccountClient.requestEmailVerification(userId);
  }
}

export default new AccountService();
